import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const OrderDetailModal = ({ open, setOpen, orderNumber, data }) => {
  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton onClick={handleClose} sx={{ float: 'right' }}>
          <CloseIcon />
        </IconButton>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Detail objednávky #<b>{orderNumber}</b>
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }} />
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 300 }} aria-label="simple table">
            <TableBody>
              <TableRow key={data.title} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell>Název</TableCell>
                <TableCell>{data.title}</TableCell>
              </TableRow>
              <TableRow
                key={data.year_published}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell>Rok vydání</TableCell>
                <TableCell>{data.year_published}</TableCell>
              </TableRow>
              <TableRow
                key={data.page_count}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell>Počet stran</TableCell>
                <TableCell>{data.page_count}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Modal>
  );
};

export default OrderDetailModal;
